export interface ContentCardProps {
  title: string;
  description: string;
  link: string;
  imageUrl: string | undefined;
  promotionDate: string | undefined;
  tag?: string | undefined;
  readMinutes?: string | undefined;
  backgroundColor?: string | undefined;
  textColor?: string | undefined;
  mode?: ModeEnum;
  variant?: VariantEnum;
}

export enum ModeEnum {
  ARTICLE = 'article',
  OFFER = 'offer',
}

export enum VariantEnum {
  SRP = 'srp',
  SEARCH_OVERLAY = 'searchOverlay',
}
